module.exports = __webpack_public_path__ + "img/1497839486.0239fdc6.jpg";